import { StatsEmitterServiceInterface } from './service.interface';
import { Snowplow2StatsObserverFactory } from '../../module/snowplow2/stats/observer.factory';
import { GtmStatsObserverFactory } from '../../module/gtm/stats/observer.factory';
import { StatsEmitterFactory } from '../../module/stats/emitter.factory';

const statsEmitterService = StatsEmitterFactory();

// Activate Snowplow2 dispatcher
const snowplow2Observer = Snowplow2StatsObserverFactory();
snowplow2Observer.attachListeners(statsEmitterService);

// Activate GTM dispatcher on every platform
const gtmObserver = GtmStatsObserverFactory();
gtmObserver.attachListeners(statsEmitterService);

export function StatsEmitterService(): StatsEmitterServiceInterface {
  return statsEmitterService;
}
